import { render, staticRenderFns } from "./AddCircleIcon.vue?vue&type=template&id=05dfe1e7"
import script from "./AddCircleIcon.vue?vue&type=script&lang=js"
export * from "./AddCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports